import Error from "@/includes/Error";
import Validator from "@/includes/validation/Validator";
import {Formulario} from "@/includes/Formulario";
import Field from "@/includes/fields/Field";

export default class FormularioValidator extends Validator {

    private fields?: Array<Field>

    isValid(): Error {
        const errosEncontrados: Data = {}
        const error = new Error()
        this.fields?.forEach((field: Field) => {
            if (field.isEmpty()) {
                errosEncontrados[field.name] = ['Este campo é obrigatório']
            }
        })
        error.record(errosEncontrados)
        return error
    }

    setTargerForValidation(target: any): Validator {
        this.fields = target
        return this;
    }
}